// Real Equipment Data Loader
// Loads data from external JSON file (fetched at runtime to avoid bundling 16MB)
// Per produzione, usare API backend per migliori performance e caching
import { IndustrialEquipment } from "../api-models/IndustrialEquipment";

/**
 * Fetches equipment data from static JSON file
 * The JSON is served from the public folder alongside the microfrontend
 */
export async function loadEquipmentData(): Promise<IndustrialEquipment[]> {
  try {
    const baseUrl =
      process.env.REACT_APP_PUBLIC_URL || "https://eqhub.demo.witboost.com";

    // Use optimized JSON file (served as gzipped by nginx)
    // The browser automatically requests and decompresses gzip
    // nginx serves the .json.gz file automatically with gzip_static on
    const response = await fetch(`${baseUrl}/eqhub_products_optimized.json`);

    if (!response.ok) {
      throw new Error(`Failed to load equipment data: ${response.status}`);
    }

    const data = await response.json();
    // Data is already in the optimized format, no transformation needed
    return data.products || [];
  } catch (error) {
    console.error("Error loading equipment data:", error);
    return [];
  }
}

// For backward compatibility - empty array, use loadEquipmentData() instead
export const equipmentData: IndustrialEquipment[] = [];
export const mockEquipmentData: IndustrialEquipment[] = [];
